import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Collapse,
  Fade,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Container } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { AuthContext } from "../../../context/auth/authContext";
import { theme } from "../../../utilities/themes";
import { receiptContent } from "../utilities/email_service";
import {
  checkPaymentAgain,
  createCardPayment,
} from "../utilities/payment_services";
import { ReactComponent as MpesaLogo } from "../../../images/svg/mpesa.svg";
import { countryList } from "../../../utilities/countryList";
import PhoneInput from "react-phone-input-2";
import getWallets from "../utilities/getWallets";
import { AccountBalanceWallet } from "@mui/icons-material";

const Payment = ({
  totalCost,
  cinema_Name,
  showDate,
  show,
  pay,
  selectedSeats,
  experience,
  MovieName,
  MovieProviderID,
  movieId,
  setActiveStep,
}) => {
  /* #region  States */
  const [isPaying, setIsPaying] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("WALLET");
  const [cardNumber, setCardNumber] = useState("");
  const [cardCvv, setCardCvv] = useState("");
  const [cardExpDate, setCardExpDate] = useState("");
  const [cardHolderName, setCardHolderName] = useState("");
  const [processing, setProcessing] = useState(false);
  const [snackbarMsg, setSnackbaMsg] = useState({
    error: false,
    msg: "",
  });
  const [wallets, setWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [rContent, setRContent] = useState(receiptContent({}));
  const [payReferences, setReferences] = useState({
    key: "",
    reference: "",
    payload: "",
  });
  const [paymentFailed, setPaymentFailed] = useState(false);
  const [progressMessage, setProgressMessage] = useState(
    "An STK push has been sent to your phone"
  );
  const authContext = useContext(AuthContext);

  /* #endregion */

  /* #region  Styling */
  const theme2 = useTheme();
  const isMobile = useMediaQuery(theme2.breakpoints.down("sm"));
  const spanFontSizes1 = {
    fontSize: { lg: "1rem", md: "1rem", sm: "0.875rem", xs: "0.875rem" },
  };
  const Text1 = ({ children, variant = "h6" }) => {
    return (
      <Typography variant={variant} sx={{ ...spanFontSizes1 }}>
        {children}
      </Typography>
    );
  };
  const Text2 = ({ children }) => {
    return (
      <>
        <Typography
          component="span"
          textTransform={"uppercase"}
          fontWeight={300}
          sx={{ ...spanFontSizes1 }}
        >
          {children} *
        </Typography>
      </>
    );
  };
  /* #endregion */

  /* #region  Api calls*/

  const startPayment = () => {
    setSnackbaMsg({
      error: false,
      msg: "",
    });
    setProcessing(true);
    let content = receiptContent({
      CinemaName: cinema_Name,
      CustomerName: `${firstName} ${lastName}`,
      MovieName: MovieName,
      PaymentMethod: paymentMethod,
      SeatNumbers: Object.keys(selectedSeats).join(","),
      ShowDate: showDate,
      ShowTime: show.ShowTime,
      BookingID: "3458392",
      TotalCost: totalCost,
    });
    let paymentPayload = {};
    switch (paymentMethod) {
      case "CARD":
        paymentPayload = createCardPayment({
          cc_number: cardNumber,
          cc_name: cardHolderName,
          cc_cvv: cardCvv,
          cc_exp: cardExpDate,
        });
        break;
      case "MPESA":
        paymentPayload = {
          type: "MPESA",
          payment: {
            mobile: phone,
          },
        };
        break;
      default:
        paymentPayload = {
          type: "MPESA",
          payment: {
            mobile: phone,
          },
        };
        break;
    }
    setRContent(content);
    pay({
      customerEmail: email,
      content,
      paymentPayload,
      phone,
      paymentMethod,
      WalletUniqueID: paymentMethod === "WALLET" ? selectedWallet : "",
    })
      .then((response) => {
        setProcessing(false);
        setSnackbaMsg({
          error: false,
          msg: "Payment succeeded",
        });
        setSnackbarOpen(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.stage) {
          switch (err.stage) {
            case "payment":
              let data = err.data;
              setReferences({
                key: data.payment_key,
                payload: data.payload,
                reference: data.payment_reference,
              });

              setProcessing(false);
              setSnackbaMsg({
                error: true,
                msg:
                  paymentMethod === "MPESA"
                    ? "Payment not found"
                    : "Payment failed",
              });
              setSnackbarOpen(true);
              setPaymentFailed(true);
              break;
            case "booking":
              setProcessing(false);
              setSnackbaMsg({
                error: true,
                msg:
                  err.data.Message ||
                  "Booking failed, we have refunded your money",
              });
              setSnackbarOpen(true);
              setPaymentFailed(true);
              break;

            default:
              setProcessing(false);
              setSnackbaMsg({
                error: true,
                msg: "Payment failed",
              });
              setSnackbarOpen(true);
              setPaymentFailed(true);
              break;
          }
        } else {
          setProcessing(false);
          setSnackbaMsg({
            error: true,
            msg: "Payment failed",
          });
          setSnackbarOpen(true);
          setPaymentFailed(true);
        }
      });
  };

  const retryPayment = () => {
    setSnackbaMsg({
      error: false,
      msg: "",
    });
    setProcessing(true);
    if (paymentMethod === "MPESA") {
      checkPaymentAgain(
        payReferences.key,
        payReferences.payload,
        payReferences.reference,
        rContent,
        email
      )
        .then((response) => {
          setProcessing(false);
          setSnackbaMsg({
            error: false,
            msg: "Payment succeeded",
          });
          setSnackbarOpen(true);
        })
        .catch((error) => {
          setProcessing(false);
          setSnackbaMsg({
            error: true,
            msg: "Payment not found",
          });
          setSnackbarOpen(true);
        });
    } else {
      startPayment();
    }
  };

  useEffect(() => {
    if (authContext.loggedIn) {
      //console.log(authContext.userDetails);
      setFirstName(authContext.userDetails.FullName.split(" ")[0]);
      setLastName(authContext.userDetails.FullName.split(" ")[1]);
      setEmail(authContext.userDetails.EMailID);
      setPhone(authContext.userDetails.MobileNumber);
      setIsPaying(true);
      getWallets(authContext.userDetails.MobileNumber).then((wallets) => {
        setWallets(wallets);
        setSelectedWallet(wallets[0].WalletID);
      });
    } else {
      setPhone(authContext.userDetails.MobileNumber);
    }
    // eslint-disable-next-line
  }, [authContext.loggedIn]);
  /* #endregion */

  return (
    <Stack spacing={2}>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          {
            //#region order details
          }
          <Grid item xs={12} md={4}>
            <Typography
              variant="h5"
              fontSize={{
                xs: "1.25rem",
                sm: "2.1rem",
              }}
            >
              Your order:
            </Typography>
            <Paper
              elevation={2}
              sx={{
                p: 3,
                border: `1px solid rgb(200,200,200)`,
                bgColor: theme.palette.primary.main,
              }}
            >
              <Stack spacing={1}>
                <Typography
                  variant="h3"
                  sx={{ fontFamily: "Montserrat", fontWeight: 700 }}
                  fontSize={{
                    xs: "2rem",
                    sm: "3rem",
                  }}
                >
                  KES&nbsp;{totalCost}
                </Typography>
                <Box
                  sx={{
                    borderTopLeftRadius: 1,
                    borderTopRightRadius: 1,
                    backgroundColor: theme.palette.primary.main,
                    width: "100%",
                    height: "0.5vh",
                  }}
                />
                <Text1>
                  Cinema:&nbsp;
                  <span style={{ fontWeight: 300 }}>{cinema_Name}</span>
                </Text1>
                {/* <Text1>
                  Experience:&nbsp;
                  <span style={{ fontWeight: 300 }}>{experience}</span>
                </Text1> */}
                <Text1>
                  Show:&nbsp;
                  <span style={{ fontWeight: 300 }}>
                    {show.ShowTime}&nbsp;{show.ScreenName}
                  </span>
                </Text1>
                <Text1>
                  Date:&nbsp;<span style={{ fontWeight: 300 }}>{showDate}</span>
                </Text1>

                <Text1>
                  <Stack
                    direction={"row"}
                    flexWrap="wrap"
                    alignItems={"center"}
                  >
                    Seats:&nbsp;
                    {Object.values(selectedSeats).map((seat, index) => (
                      <span
                        key={seat.TicketCode + seat.SeatNumber}
                        style={{ fontWeight: 300 }}
                      >
                        {seat.SeatNumber},
                      </span>
                    ))}
                  </Stack>
                </Text1>
              </Stack>
            </Paper>
          </Grid>
          {
            //#endregion
          }
          {
            //#region payment info
          }
          <Grid item xs={12} md={8}>
            <Typography
              variant="h5"
              fontSize={{
                xs: "1.25rem",
                sm: "2.1rem",
              }}
            >
              {!isPaying ? <>Enter your name and email:</> : <>Payment:</>}
            </Typography>
            <Paper
              elevation={2}
              sx={{ p: 3, border: "1px solid rgb(200,200,200)" }}
            >
              <Stack spacing={2}>
                {
                  //#region Name email phone
                }
                <Collapse in={!isPaying}>
                  <ValidatorForm
                    onSubmit={() => {
                      setIsPaying(true);
                    }}
                  >
                    <Stack spacing={2}>
                      <Stack
                        direction={isMobile ? "column" : "row"}
                        spacing={2}
                        justifyContent={{ xs: "start", md: "space-between" }}
                      >
                        <Stack
                          sx={{
                            ...spanFontSizes1,
                            width: "45%",
                          }}
                        >
                          <Text2>First name</Text2>
                          <TextValidator
                            name="firstName"
                            value={firstName}
                            onChange={(event) =>
                              setFirstName(event.target.value)
                            }
                            color="secondary"
                            size="small"
                            validators={["required"]}
                            errorMessages={["this field is required"]}
                            fullWidth={true}
                            style={{ height: "6vh" }}
                          />
                        </Stack>
                        <Stack
                          style={{
                            width: "45%",
                          }}
                        >
                          <Text2>Last name</Text2>
                          <TextValidator
                            name="lastName"
                            value={lastName}
                            onChange={(event) =>
                              setLastName(event.target.value)
                            }
                            color="secondary"
                            size="small"
                            validators={["required"]}
                            errorMessages={["this field is required"]}
                            fullWidth={true}
                            style={{ height: "6vh" }}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={isMobile ? "column" : "row"}
                        spacing={{ xs: 2, md: 0 }}
                        justifyContent={{ xs: "start", md: "space-between" }}
                      >
                        {!authContext.userDetails.MobileNumber && (
                          <Stack
                            style={{
                              width: "45%",
                            }}
                          >
                            <Text2>Phone number</Text2>

                            <PhoneInput
                              country={"ke"}
                              value={phone}
                              onChange={(phone, data) => {
                                setPhone(phone);
                              }}
                              placeholder="+254x xxx xxx"
                              onlyCountries={countryList}
                              specialLabel=""
                              inputStyle={{
                                height: "6vh",
                              }}
                            />
                          </Stack>
                        )}

                        <Stack
                          style={{
                            width: "45%",
                          }}
                        >
                          <Text2>Email</Text2>
                          <TextValidator
                            name="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            type="email"
                            color="secondary"
                            size="small"
                            validators={["required", "isEmail"]}
                            errorMessages={[
                              "this field is required",
                              "email is not valid",
                            ]}
                            style={{ height: "6vh" }}
                            fullWidth={true}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        direction="row-reverse"
                        justifyContent={"space-between"}
                      >
                        <Button
                          variant="contained"
                          type="submit"
                          onSubmit={() => setIsPaying(true)}
                        >
                          Submit
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          onSubmit={() => {
                            setActiveStep(0);
                            setPaymentFailed(false);
                            setReferences({
                              key: "",
                              reference: "",
                              payload: "",
                            });
                          }}
                        >
                          Back
                        </Button>
                      </Stack>
                    </Stack>
                  </ValidatorForm>
                </Collapse>
                {
                  //#endregion
                }
                {
                  //#region payment info
                }
                <Collapse in={isPaying}>
                  <ValidatorForm
                    onSubmit={() => {
                      if (
                        !paymentFailed ||
                        (paymentFailed && payReferences.key)
                      ) {
                        startPayment();
                        switch (paymentMethod) {
                          case "MPESA":
                            setProgressMessage(
                              "An STK push has been sent to your phone"
                            );
                            break;
                          case "CARD":
                            setProgressMessage("Processing card payment");
                            break;
                          default:
                            setProgressMessage(
                              "An STK push has been sent to your phone"
                            );
                            break;
                        }
                      } else {
                        setActiveStep(0);
                        setPaymentFailed(false);
                        setReferences({
                          key: "",
                          reference: "",
                          payload: "",
                        });
                      }
                    }}
                  >
                    <Stack spacing={2}>
                      <Stack spacing={2}>
                        {
                          //#region toggle mpesa/card/wallet
                        }
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          spacing={2}
                        >
                          <Button
                            variant={
                              paymentMethod === "WALLET"
                                ? "contained"
                                : "outlined"
                            }
                            sx={{ borderRadius: "500px" }}
                            disableElevation
                            onClick={() => setPaymentMethod("WALLET")}
                          >
                            {isMobile ? <>Wallet</> : <>Little wallet</>}
                          </Button>
                          <Button
                            variant={
                              paymentMethod === "CARD"
                                ? "contained"
                                : "outlined"
                            }
                            sx={{ borderRadius: "500px" }}
                            disableElevation
                            onClick={() => setPaymentMethod("CARD")}
                          >
                            Card
                          </Button>
                          <Button
                            variant={
                              paymentMethod === "MPESA"
                                ? "contained"
                                : "outlined"
                            }
                            sx={{ borderRadius: "500px" }}
                            disableElevation
                            onClick={() => setPaymentMethod("MPESA")}
                          >
                            Mpesa
                          </Button>
                        </Stack>
                        {
                          //#endregion
                        }
                        {paymentMethod === "CARD" && (
                          <Fade in>
                            <Grid container width={"100%"}>
                              <Grid item xs={12} md={6}>
                                <Stack p={1}>
                                  <Text2>Card number</Text2>
                                  <TextValidator
                                    color="secondary"
                                    id="ccn"
                                    type="tel"
                                    inputMode="numeric"
                                    pattern="[0-9\s]{13,19}"
                                    autoComplete="cc-number"
                                    maxLength="19"
                                    value={cardNumber}
                                    onChange={(event) =>
                                      setCardNumber(event.target.value)
                                    }
                                    placeholder="xxxx xxxx xxxx xxxx"
                                    validators={[
                                      "required",
                                      "matchRegexp:[0-9]{13,19}",
                                    ]}
                                    errorMessages={[
                                      "this field is required",
                                      "Enter a valid credit card number",
                                    ]}
                                    fullWidth={true}
                                  />
                                </Stack>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Stack p={1}>
                                  <Text2>CVV</Text2>
                                  <TextValidator
                                    color="secondary"
                                    id="cvv"
                                    type="number"
                                    inputMode="numeric"
                                    maxLength="3"
                                    pattern="[0-9]*"
                                    placeholder="xxx"
                                    value={cardCvv}
                                    onChange={(event) =>
                                      setCardCvv(event.target.value)
                                    }
                                    validators={[
                                      "required",
                                      "matchRegexp:[0-9]*",
                                    ]}
                                    errorMessages={[
                                      "this field is required",
                                      "Enter a valid CVV",
                                    ]}
                                    fullWidth={true}
                                  />
                                </Stack>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Stack p={1}>
                                  <Text2>Card expiry date</Text2>
                                  <TextValidator
                                    color="secondary"
                                    id="ced"
                                    type="text"
                                    inputMode="month"
                                    pattern="[0-9]{2}/[0-9]{2}"
                                    placeholder="MM/YY"
                                    maxLength="5"
                                    value={cardExpDate}
                                    onChange={(event) =>
                                      setCardExpDate(event.target.value)
                                    }
                                    validators={[
                                      "required",
                                      "matchRegexp:[0-9]{2}/[0-9]{2}",
                                    ]}
                                    errorMessages={[
                                      "this field is required",
                                      "Enter the expiry date in MM/YY format. eg 04/25",
                                    ]}
                                    fullWidth={true}
                                  />
                                </Stack>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Stack p={1}>
                                  <Text2>Card Holder Name</Text2>
                                  <TextValidator
                                    color="secondary"
                                    id="chn"
                                    type="text"
                                    value={cardHolderName}
                                    onChange={(event) =>
                                      setCardHolderName(event.target.value)
                                    }
                                    validators={["required"]}
                                    errorMessages={["this field is required"]}
                                    fullWidth={true}
                                  />
                                </Stack>
                              </Grid>
                            </Grid>
                          </Fade>
                        )}
                        {paymentMethod === "MPESA" && (
                          <Fade in>
                            {processing ? (
                              <Stack
                                minHeight={"35vh"}
                                alignItems={"center"}
                                justifyContent="center"
                              >
                                <CircularProgress />
                                <Typography component="span">
                                  {progressMessage}
                                </Typography>
                              </Stack>
                            ) : (
                              <Stack
                                minHeight={"35vh"}
                                width="100%"
                                spacing={2}
                              >
                                <MpesaLogo className="mpesaLogo" />
                                <Text2>
                                  Mpesa STK push will be sent to the following
                                  number:
                                </Text2>

                                <PhoneInput
                                  country={"ke"}
                                  value={phone}
                                  onChange={(phone, data) => {
                                    setPhone(phone);
                                    setPaymentFailed(false);
                                  }}
                                  style={{
                                    ...(isMobile && {
                                      width: "100%",
                                    }),
                                  }}
                                  inputStyle={{
                                    ...(isMobile && {
                                      width: "100%",
                                    }),
                                  }}
                                  placeholder="+254x xxx xxx"
                                  onlyCountries={countryList}
                                />
                              </Stack>
                            )}
                          </Fade>
                        )}
                        {paymentMethod === "WALLET" && (
                          <Fade in>
                            <Stack minHeight={"35vh"} width="100%" spacing={2}>
                              <Stack width="100%" alignItems="center">
                                <AccountBalanceWallet
                                  color="primary"
                                  fontSize="large"
                                />
                                <Text1>Little Wallet</Text1>
                              </Stack>
                              <Stack spacing={1}>
                                <Text2>Please select a wallet</Text2>
                                <FormControl>
                                  <InputLabel id="walletsLabel">
                                    Wallets
                                  </InputLabel>
                                  <Select
                                    label="Wallets"
                                    labelId="walletsLabel"
                                    value={selectedWallet}
                                    onChange={(event) =>
                                      setSelectedWallet(event.target.value)
                                    }
                                  >
                                    {wallets.map((wallet) => (
                                      <MenuItem
                                        value={wallet.WalletID}
                                        key={wallet.WalletID}
                                      >
                                        {wallet.WalletName}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Stack>
                            </Stack>
                          </Fade>
                        )}
                      </Stack>
                      {
                        //#region submit and back buttons
                      }
                      <Stack
                        direction={{ xs: "column", sm: "row-reverse" }}
                        justifyContent={{ xs: "start", sm: "space-between" }}
                        spacing={2}
                      >
                        <Stack
                          direction={{ xs: "column", sm: "row" }}
                          spacing={2}
                        >
                          {paymentMethod === "MPESA" &&
                            paymentFailed &&
                            payReferences.key && (
                              <Button
                                variant="outlined"
                                onClick={() => {
                                  retryPayment();
                                  setProgressMessage(
                                    "Checking for mpesa payment"
                                  );
                                }}
                                disabled={processing}
                              >
                                I have already paid
                              </Button>
                            )}
                          <Button
                            variant="contained"
                            type="submit"
                            disabled={processing}
                          >
                            {processing && paymentMethod !== "MPESA" && (
                              <>
                                <CircularProgress size={"16px"} />
                                &nbsp;
                              </>
                            )}
                            {paymentMethod === "MPESA" ? (
                              paymentFailed ? (
                                payReferences.key ? (
                                  <>Re-Send Mpesa STK</>
                                ) : (
                                  <>Book another seat</>
                                )
                              ) : (
                                <>Send Mpesa STK</>
                              )
                            ) : paymentFailed ? (
                              payReferences.key ? (
                                <>Retry</>
                              ) : (
                                <>Book another seat</>
                              )
                            ) : (
                              <>Done</>
                            )}
                          </Button>
                        </Stack>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            if (!authContext.loggedIn) {
                              setIsPaying(false);
                            } else {
                              setActiveStep(0);
                              setPaymentFailed(false);
                              setReferences({
                                key: "",
                                reference: "",
                                payload: "",
                              });
                            }
                          }}
                        >
                          Back
                        </Button>
                      </Stack>
                      {snackbarMsg.msg && snackbarMsg.error && (
                        <Stack
                          direction="row-reverse"
                          justifyContent={"space-between"}
                        >
                          <Typography variant="body1" color={"red"}>
                            {snackbarMsg.msg}
                          </Typography>
                        </Stack>
                      )}
                      {
                        //#endregion
                      }
                    </Stack>
                  </ValidatorForm>
                </Collapse>
                {
                  //#endregion
                }
              </Stack>
            </Paper>
          </Grid>
          {
            //#endregion
          }
        </Grid>
      </Container>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity={snackbarMsg.error ? "error" : "success"}
          sx={{ width: "100%" }}
        >
          {snackbarMsg.msg}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default Payment;
